import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  starCount: z.number().int().min(3).max(10).default(5),
  allowHalf: z.boolean().default(false),
});

export const ratingField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "rating",
  label: "Star rating",
  category: "rating",
  icon: "Star",
  configSchema,
  valueSchema: (config, isRequired) => {
    let schema = z
      .number()
      .min(config.allowHalf ? 0.5 : 1)
      .max(config.starCount);
    if (!config.allowHalf) schema = schema.int("Choose a whole number of stars");
    return optionalUnlessRequired(schema, isRequired);
  },
  defaultConfig: { starCount: 5, allowHalf: false },
  supportsProfileBinding: false,
  defaultSearchable: false,
  sortKind: "numeric",
  renderHints: {},
};
